export const getOauthSuccessDrawerConfig = ({ onSuccessConfig } = {}) =>
  onSuccessConfig?.drawerType ? onSuccessConfig : null
